import React, { PropTypes } from 'react';
import { ListItem } from 'material-ui/List';
import { DragSource } from 'react-dnd';

const knightSource = {
  beginDrag(props) {
    return {
      type: 'Player',
      listContent: props.listContent,
      id: props.id
    }
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  }
}

class PlayerListItem extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    listContent: PropTypes.object,
    connectDragSource: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired
  };

  render() {
    const { connectDragSource, connectDragPreview, ...other } = this.props;

    return connectDragSource(
      <div style={{
        minWidth: 200,
        cursor: 'move'
      }}>
       {connectDragPreview(
         <span>
           <ListItem {...other}/>
         </span>

       )}
      </div>
    );
  }
}

export default DragSource('Player', knightSource, collect)(PlayerListItem);





// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/PlayerListContent/PlayerListItem.js